import React, {Component} from 'react';
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import {UncontrolledTooltip} from 'reactstrap';
import Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment';
import 'moment/locale/tr';

class DespatchReferenceList extends Component{
	constructor(props) {
		super(props);
		this.state ={
			error:{},
			despatchReferences:[]
		};
		this.addDespatchReference 		= this.addDespatchReference.bind(this);
		this.removeDespatchReference 	= this.removeDespatchReference.bind(this);
		this.onChange 		= this.onChange.bind(this);
		this.validateField  = this.validateField.bind(this);
	}

	componentWillMount() {
		let despatchReferences = this.props.despatchReferences;
		this.setState({despatchReferences});
	}

	addDespatchReference(e){
		let despatchReferences = deepCopyObject(this.state.despatchReferences);
		despatchReferences.push({recordId:null,referenceId:'', referenceIssueDate:''});
		this.props.listener(despatchReferences);
		this.setState({despatchReferences});
	}

	removeDespatchReference(e,index){
		let despatchReferences = deepCopyObject(this.state.despatchReferences);
		despatchReferences.splice(index, 1);
		this.props.listener(despatchReferences);
		this.setState({despatchReferences});
	}

	onChange(e,index){
		let despatchReferences = deepCopyObject(this.state.despatchReferences);
		despatchReferences[index][e.target.name]= e.target.value;
		this.props.listener(despatchReferences);
		this.setState({despatchReferences});
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
		this.props.errorListener(error);
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	componentWillReceiveProps(nextProps){
		if(this.props.error !== nextProps.error){
			this.setState({error:nextProps.error});
		}

		if (nextProps.manual) {
			this.setState({despatchReferences: nextProps.despatchReferences,error:{}});
			this.props.isManual(false);
			this.props.errorListener({});
		}
	}

	render(){
		return (
			<div className="col-sm-12">
				<table style={{textAlign: 'center'}}>
					<thead>
						<tr style={{backgroundColor: '#ebedf0'}}>
							<th width="20%" >İrsaliye No</th>
							<th width="25%">İrsaliye Tarihi</th>
							{
								this.props.externalCustomer && this.props.externalCustomer.vknTckn === "2940035696" && this.props.profileId === "EFATURA" &&
									<th width="25%">Fiili Sevk Tarihi</th>
							}
							{"EBELGE" !== this.props.profileId &&
								<th width="10%">İşlemler</th>
							}
						</tr>
					</thead>
					<tbody>
					{
						this.state.despatchReferences.map((despatchReference, index) =>
						<tr key={index}>
							<td className={"form-group" + this.validateClass('referenceId_' + index)}>
								<input className="form-control"
									   id={"referenceId_"+index}
									   name="referenceId"
									   type="text"
									   data-vlength={despatchReference.referenceIssueDate ? "1,255":"0,255"}
									   onBlur={this.validateField}
									   value={despatchReference.referenceId || ""}
									   onChange={(e)=>this.onChange(e,index)}/>
								{this.validateMessage("referenceId_"+index) !== "" &&
								<UncontrolledTooltip placement="right" target={"referenceId_"+index} delay={0}>
									{this.validateMessage("referenceId_"+index)}
								</UncontrolledTooltip>}
							</td>
							<td className={"form-group" + this.validateClass('referenceIssueDate_' + index)}>
								<Datetime locale="tr"
										  className="datepicker"
										  input={true}
										  inputProps={{id:"referenceIssueDate_"+index}}
										  onBlur={(momentObj)=>this.validateField({target:{id:"referenceIssueDate_"+index,dataset:{'vdata':"date",'vlength':(despatchReference.referenceId ? "1,255":"0,255")},value:(!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)}})}
										  closeOnSelect={true}
										  value={moment(despatchReference.referenceIssueDate,"YYYY-MM-DD",true).isValid() ? moment(despatchReference.referenceIssueDate).format("DD-MM-YYYY"):despatchReference.referenceIssueDate}
										  dateFormat="DD-MM-YYYY"
										  timeFormat={false}
										  isValidDate={function (current) {return current.isBefore(Datetime.moment());}}
										  onChange={(momentObj) => this.onChange({target:{name:'referenceIssueDate',value:(!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)}},index)}/>
								{this.validateMessage("referenceIssueDate_"+index) !== "" &&
								<UncontrolledTooltip placement="right" target={"referenceIssueDate_"+index} delay={0}>
									{this.validateMessage("referenceIssueDate_"+index)}
								</UncontrolledTooltip>}
							</td>
							{
								this.props.externalCustomer && this.props.externalCustomer.vknTckn === "2940035696" && this.props.profileId === "EFATURA" &&
									<td className={"form-group" + this.validateClass('despatchDate_' + index)}>
									<Datetime locale="tr"
											  className="datepicker"
											  input={true}
											  inputProps={{id:"despatchDate_"+index}}
											  onBlur={(momentObj)=>this.validateField({target:{id:"despatchDate_"+index,dataset:{'vdata':"date",'vlength':(despatchReference.referenceId ? "1,255":"0,255")},value:(!(typeof momentObj === "string") ? momentObj.format("DD-MM-YYYY") : momentObj)}})}
											  closeOnSelect={true}
											  value={moment(despatchReference.despatchDate,"YYYY-MM-DD",true).isValid() ? moment(despatchReference.despatchDate).format("DD-MM-YYYY"):despatchReference.despatchDate}
											  dateFormat="DD-MM-YYYY"
											  timeFormat={false}
											  isValidDate={function (current) {return current.isBefore(Datetime.moment());}}
											  onChange={(momentObj) => this.onChange({target:{name:'despatchDate',value:(!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)}},index)}/>
									{this.validateMessage("despatchDate_"+index) !== "" &&
										<UncontrolledTooltip placement="right" target={"despatchDate_"+index} delay={0}>
											{this.validateMessage("despatchDate_"+index)}
										</UncontrolledTooltip>}
								</td>
							}
							{"EBELGE" !== this.props.profileId &&
							<td>
								{this.state.despatchReferences.length !== 1 &&
								<button type="button" rel="tooltip"
										onClick={(e) => this.removeDespatchReference(e, index)} data-placement="left"
										title="İrsaliye Bilgisini Sil" className="Btn temizle"
										style={{
											background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
											marginRight: '3px'
										}}>
								</button>
								}
								{this.state.despatchReferences.length === index + 1 && "EBELGE" !== this.props.profileId &&
								<button type="button" rel="tooltip" onClick={(e) => this.addDespatchReference(e)}
										data-placement="left"
										title="İrsaliye Bilgisini Ekle" className="Btn ekle">
								</button>
								}
							</td>}
						</tr>)
						}
					</tbody>
				</table>
			</div>
		);
	}
}

export default DespatchReferenceList;